import React from 'react';
import { useSelector } from 'react-redux';

import Spin from 'antd/es/spin';
import { Route, Switch } from 'react-router-dom';
import Header from '../../components/header';
import Footer from '../../components/footer';
import ServicesRoutes from './services';
import MobileNav from '../client/components/mobileNav';

const HomeRoute = React.lazy(() => import('./home'));
const AccessDeniedRoute = React.lazy(() => import('./accessDenied'));
const NotFoundRoute = React.lazy(() => import('../notFound'));
const SalesOrderRoute = React.lazy(() => import('./salesOrder'));
const ContactRoute = React.lazy(() => import('./contact'));
const AboutRoute = React.lazy(() => import('./about'));
const TurnaroundTimesRoute = React.lazy(() => import('./turnaroundTimes'));
const CovidRoute = React.lazy(() => import('./covid'));
const TaxidermyStarsInfoRoute = React.lazy(() => import('./taxidermyStarsInfo'));
const CheckOrderRoute = React.lazy(() => import('./checkOrder'));
// const Maintenance = React.lazy(() => import('./maintenance'));

function PublicRoutes() {
    const { loggedIn } = useSelector(state => state.authentication);

    return (
        <>
            <div className="wrapper">
                <Header />
                <React.Suspense fallback={<Spin className="center" />}>
                    <Switch>
                        {/* <Route path="/" exact component={Maintenance} /> */}
                        <Route path="/" exact component={HomeRoute} />
                        <Route path="/403" exact component={AccessDeniedRoute} />
                        <Route path="/about" exact component={AboutRoute} />
                        <Route path="/turnaround" exact component={TurnaroundTimesRoute} />
                        <Route path="/contact" exact component={ContactRoute} />
                        <Route path="/payment" exact component={SalesOrderRoute} />
                        <Route path="/covid-19" exact component={CovidRoute} />
                        <Route
                            path="/(tanning-services|prices|resources|legal-compliance|forms|privacy-policy)/"
                            exact
                            component={ServicesRoutes}
                        />
                        <Route
                            path="/taxidermy-stars-info"
                            exact
                            component={TaxidermyStarsInfoRoute}
                        />
                        <Route path="/check-order" exact component={CheckOrderRoute} />
                        <Route path="*" exact component={NotFoundRoute} />
                        {/* <Route path="*" exact component={Maintenance} /> */}
                    </Switch>
                </React.Suspense>
            </div>
            {loggedIn && <MobileNav />}
            <Footer />
        </>
    );
}

export default PublicRoutes;
